import { FunctionalComponent } from "preact";

import { Heading, Link, Text } from "@/uikit";

import { OfferData } from "@/pages/Earn/offers";
import { ModalControls } from "@/uikit/Modal";

type EarnModalProps = {
  controls: ModalControls;
  offer: OfferData;
};

export const EarnModal: FunctionalComponent<EarnModalProps> = (
  { controls, offer },
) => {
  return (
    <div className="earn-modal gap-vertical">
      <Heading level={2}>Disclaimer</Heading>
      <Text>
        Unlike staking TON with Tonstakers,
        <br />
        <br />
        Using DeFi protocols (including but not limited to lending protocols,
        decentralized exchanges, and farms) carries additional risk.
        <br />
        <br />
        By proceeding, the user confirms their understanding and acceptance of
        this risk and takes full responsibility for any possible consequences
        arising from the use of third-party apps.
      </Text>
      <Link
        className="button"
        href={offer.url}
        onClick={() => controls.close()}
      >
        <Text weight="semibold" variant="h4">
          I understand & accept the Risk
        </Text>
      </Link>
    </div>
  );
};
